import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    const {
        canCopyIdePromptBd,
        canCopyIdePromptBdlogic,
        canCopyIdePromptIsrf,
        canCopyIdePromptUe,
        canCopyIdePromptUi,
        copyIdePromptBd,
        copyIdePromptBdlogic,
        copyIdePromptIsrf,
        copyIdePromptUe,
        copyIdePromptUi,
    } = map.commands

    let copyIdePrompt
    let nodes

    for (
        const [canCopy, copy] of

        [
            [canCopyIdePromptBd, copyIdePromptBd],
            [canCopyIdePromptBdlogic, copyIdePromptBdlogic],
            [canCopyIdePromptIsrf, copyIdePromptIsrf],
            [canCopyIdePromptUe, copyIdePromptUe],
            [canCopyIdePromptUi, copyIdePromptUi],
        ]
    ) {
        const ns = canCopy(selectedNodes)

        if (0 < ns.length) {
            copyIdePrompt = copy
            nodes = ns
            break
        }
    }

    if (! nodes) {
        return null
    }

    if (
        copyIdePromptBd === copyIdePrompt ||
        copyIdePromptBdlogic === copyIdePrompt
    ) {
        return {
            label: '复制Spec',

            children: [
                {
                    label: '复制Spec2',
                    onClick: () => copyIdePrompt(nodes, 2),
                },

                {
                    label: '复制Spec3',
                    onClick: () => copyIdePrompt(nodes, 3),
                }
            ],
        }
    }
    else if (
        copyIdePromptIsrf === copyIdePrompt ||
        copyIdePromptUe === copyIdePrompt ||
        copyIdePromptUi === copyIdePrompt
    ) {
        return {
            label: '复制Spec',

            children: [
                {
                    label: '复制Spec1',
                    onClick: () => copyIdePrompt(nodes, 1),
                },

                {
                    label: '复制Spec2',
                    onClick: () => copyIdePrompt(nodes, 2),
                },

                {
                    label: '复制Spec3',
                    onClick: () => copyIdePrompt(nodes, 3),
                }
            ],
        }
    }
    else {
        return {
            label: '复制Spec',
            onClick: () => copyIdePrompt(nodes),
        }
    }
}
